<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>January 30</h1>
          <p>Arrived at Heathrow at 10:20am</p>
          <p>Spoke to Frank his flight to Iceland was cancelled too.</p>   
          <p>As I could call Frank but his UK sim did not allow him to call me I got a UK SIM for the gambling/share trading phone.</p>
          <p>Frank picked up the hire car and did not want to go to Gatwick to pick me up so said to get on a train and go somewhere he could drive to.</p>   
          <p>I got a train to Brighton.  Went to the pub across the road and got lunch.</p>   
          <p>Frank could not find me.  Eventually I agreed to get a train to Falmer as that is where Frank eneded up.</p>   
          <p>We then drove aimlessly for a while.  Then we booked a hotel in the middle of nowhere.</p>   
          <p>They said they just turned on the heating so it will take a while to warm up.  It never warmed up I slept with a hoodie on it was so cold.</p>   
          <p>When the fire alarm went off at 5:50am I found out you have to turn the heater one first.  Then I found the electric heater that was just sitting there.</p>   
          <p>Now I can update this!</p>   
          <a href="https://www.booking.com/hotel/gb/the-lodge-at-winchelsea.en-gb.html?aid=318615&label=cc1_English_Australia_EN_AU_165353930594-SLYY4mciZrkKz33GgGxHEQS700430396602%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg&sid=54cd8ca139794a2417d39f9bce733659&age=0&all_sr_blocks=28944802_348279576_3_1_0&checkin=2025-02-10&checkout=2025-02-22&dest_id=-2611812&dest_type=city&dist=0&group_adults=1&group_children=1&hapos=1&highlighted_blocks=28944802_348279576_3_1_0&hpos=1&matching_block_id=28944802_348279576_3_1_0&no_rooms=1&req_adults=1&req_age=0&req_children=1&room1=A%2C0&sb_price_type=total&sr_order=popularity&sr_pri_blocks=28944802_348279576_3_1_0__162162&srepoch=1738394593&srpvid=7ed933ee8e46043c&type=total&ucfs=1&">Winchelsea Lodge</a>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>